export interface AppPage {
  url: string;
  icon: string;
  title: string;
}

export interface Target1 {
  description: string
  target: string
  sales: number
  ach: number
}

export interface CustomerFollowUpHistoryItem {
  id: number;
  customer_id: string;
  customer?: {
    customer_id: string;
    customer_name: string;
  };
  follow_up_date: string;
  next_follow_up?: string | null;
  status: string;
  contact_method: string;
  notes?: string | null;
  created_by?: string;
  updated_by?: string | null;
}

export interface PhotoWithDescription {
  photo: any;
  description: string;
}

export interface Target2 {
  name: string;
  type: string;
  budget: number;
  quantity: number;
  amount: number;
  sales: number;
  target: number;
  total: number;
}

export interface Achievement {
  paymentSystem: string
  duedate: number
  allowance: number
  duedateAndAllowace: number
  totalAllowance: number
}

export interface LoadItem {
  i: number;
}

export const loadList: LoadItem[] = [
  {
    i: 0,
  },
  {
    i: 1,
  },
  {
    i: 2,
  },
  {
    i: 3,
  },
  {
    i: 4,
  },
  {
    i: 5,
  },
  {
    i: 6,
  },
  {
    i: 7,
  },
  {
    i: 8,
  },
  {
    i: 9,
  },
];

export interface Item {
  text: string;
  value: string;
}

export interface SelectOptionProps {
  items: Item[];
  selectedItems: string[];
  title?: string;
  multiple: boolean;
  onSelectionCancel: () => void;
  onSelectionChange: (items: string[]) => void;
  isOpen: boolean;
}
export interface DateProps {
  onCloseModal: any;
  initialData: any;
  isOpen: boolean;
  min?: string; // e.g., "2023-08-02"
}

export interface Discount {
  [key: string]: number;
}

export type ActionCollect =
  | {
      type: "UPDATE_FIELD";
      payload: { index: number; fieldPath: string; value: any };
    }
  | { type: "ADD_COLLECTION_ENTRY"; payload: { index: number } }
  | {
      type: "DELETE_COLLECTION_ENTRY";
      payload: { invoiceIndex: number; collectIndex: number };
    };


export interface ApiResponse {
  data: {
    status: boolean;
    message: string;
    data?: any;
    token?: string;
    code?: number;
  };
}

export interface ItemDetailModal {
  item_id: string;
  onDismissDetail: () => void;
}

export interface ItemInventory {
  item_id: string;
  item_name: string;
  item_unit: string;
  item_is_active: number;
  item_is_stock: number;
  item_is_allowhpp: number;
  item_category_id: string;
  item_part_no: string;
  item_on_hand: number;
  item_on_order: number;
  item_on_sales: number;
  item_taxable: number;
  item_buying_price: number;
  item_selling_price: number;
  item_price_list1: number;
  item_price_list2: number;
  item_price_list3: number;
  item_weight: number;
  item_width: number;
  item_depth: number;
  item_height: number;
  item_total_height: number;
  item_stock_index: number;
  item_point: number;
  item_tag: string | null;
  item_account_inventory: number;
  item_account_sales: number;
  item_account_sales_disc: number;
  item_account_sales_return: number;
  item_account_cogs: number;
  item_account_purchase_return: number;
  item_create_at: string;
  item_create_by: string;
  item_update_at: string;
  item_update_by: string;
  item_last_update: string;
  total_in: number;
  total_out: number;
  total_stock: number;
  category?: {
    category_id: string;
    category_name: string;
    category_is_active: number;
    category_brand_id: string;
    category_grouping_id: string;
    category_create_at: string;
    category_create_by: string;
    category_update_at: string;
    category_update_by: string;
    category_last_update: string;
    grouping?: {
      grouping_id: string;
      grouping_name: string;
      grouping_sequence: number;
      grouping_is_active: number;
      grouping_create_at: string | null;
      grouping_create_by: string;
      grouping_update_at: string | null;
      grouping_update_by: string | null;
      grouping_last_update: string;
    };
  };
  inventorydet?: Array<{
    inventory?: {
      inventory_id: number;
      inventory_form_no: string;
      inventory_type: "IN" | "OUT";
      inventory_type_document: string;
      inventory_date?: string;
      inventory_create_by?: string;
      inventory_create_at?: string;
      inventory_update_by?: string;
      inventory_update_at?: string;
      warehouse?: {
        warehouse_name: string;
      };
      customer?: {
        customer_name: string;
      };
    };
    inventorydet_quantity: number;
  }>;
}

export interface Warehouse {
  warehouse_id: string;
  warehouse_name: string;
}
export interface Category {
  category_id: string;
  category_name: string;
}

export interface Grouping {
  grouping_id: string;
  grouping_name: string;
}

export interface FilterProps {
  items: any;
  selectedItems: any;
  onFilterCancel: () => void;
  onFilterChange: (items: any) => void;
}

export interface CollectionEntry {
  id: number;
  amount: number;
  type: "CASH" | "TRANSFER" | "GIRO" | "DV";
}

export interface InvoiceCollectItem {
  invoice: any; // Ideally replace with a proper type
  remark: string;
  image: any; // Replace with Photo type if possible
  collect: CollectionEntry[];
}